import enumToObject from 'utils/enumToObject';
import { colors } from 'constants/colors';
import resolvePath from 'utils/resolvePath';
export const QuestionnaireLabelsWorld = [
    'Easy-to-understand Japanese',
    'Slow Conversation Speed',
    'Good Video Quality',
];
export const QuestionnaireLabelsWorldIntlid = [
    'questionnaire.step_2.label_1',
    'questionnaire.step_2.label_2',
    'questionnaire.step_2.label_3',
];
export const QuestionnaireLabelsJP = [
    '日本語でのおしゃべりがスムーズだった',
    '積極的に話しかけてくれた',
    'ビデオ通話の品質がよかった',
];
export const headerTexts = [
    {
        headerIntl: 'questionnaire.step_1.heading',
        subHeaderIntl: 'questionnaire.step_1.subheading',
    },
    {
        headerIntl: 'questionnaire.step_2.heading',
        subHeaderIntl: 'questionnaire.step_2.subheading',
    },
    {
        headerIntl: 'questionnaire.step_3.heading',
        subHeaderIntl: 'questionnaire.step_3.subheading',
    },
    {
        headerIntl: 'questionnaire.step_4.heading',
        subHeaderIntl: 'questionnaire.step_4.subheading',
    },
];
export var ConversationCategory;
(function (ConversationCategory) {
    ConversationCategory[ConversationCategory["Other"] = 0] = "Other";
    ConversationCategory[ConversationCategory["DailyLife"] = 1] = "DailyLife";
    ConversationCategory[ConversationCategory["Work"] = 2] = "Work";
    ConversationCategory[ConversationCategory["Travel"] = 3] = "Travel";
    ConversationCategory[ConversationCategory["PartnersCountry"] = 4] = "PartnersCountry";
})(ConversationCategory || (ConversationCategory = {}));
export var ReportReason;
(function (ReportReason) {
    ReportReason[ReportReason["OtherServices"] = 1] = "OtherServices";
    ReportReason[ReportReason["Spam"] = 2] = "Spam";
    ReportReason[ReportReason["Obscenity"] = 3] = "Obscenity";
    ReportReason[ReportReason["Criminal"] = 4] = "Criminal";
    ReportReason[ReportReason["Other"] = 5] = "Other";
    ReportReason[ReportReason["PartnerUnable"] = 6] = "PartnerUnable";
})(ReportReason || (ReportReason = {}));
export const conversationCategories = {
    [ConversationCategory.Other]: 'evaluation.memo-0',
    [ConversationCategory.DailyLife]: 'evaluation.memo-1',
    [ConversationCategory.Work]: 'evaluation.memo-2',
    [ConversationCategory.Travel]: 'evaluation.memo-3',
    [ConversationCategory.PartnersCountry]: 'evaluation.memo-4',
};
export const reportCategories = {
    [ReportReason.OtherServices]: 'evaluation.report-0',
    [ReportReason.Spam]: 'evaluation.report-1',
    [ReportReason.Obscenity]: 'evaluation.report-2',
    [ReportReason.Criminal]: 'evaluation.report-3',
    [ReportReason.Other]: 'evaluation.report-4',
    [ReportReason.PartnerUnable]: 'evaluation.report-5',
};
export const MEMO_STEP = 3;
const emojiNameArr = [
    'smiley_humorous',
    'smiley_impressed',
    'smiley_discovered',
    'smiley_fine',
    'smiley_uncomfortable',
];
export var satisfactionStudentEnum;
(function (satisfactionStudentEnum) {
    satisfactionStudentEnum[satisfactionStudentEnum["Very humorous"] = 1] = "Very humorous";
    satisfactionStudentEnum[satisfactionStudentEnum["Impressed"] = 2] = "Impressed";
    satisfactionStudentEnum[satisfactionStudentEnum["Discovered new"] = 3] = "Discovered new";
    satisfactionStudentEnum[satisfactionStudentEnum["Nice and fine"] = 4] = "Nice and fine";
    satisfactionStudentEnum[satisfactionStudentEnum["Uncomfortable"] = 5] = "Uncomfortable";
})(satisfactionStudentEnum || (satisfactionStudentEnum = {}));
export var satisfactionTeacherEnum;
(function (satisfactionTeacherEnum) {
    satisfactionTeacherEnum[satisfactionTeacherEnum["\u8AC7\u7B11\u3067\u304D\u305F"] = 1] = "\u8AC7\u7B11\u3067\u304D\u305F";
    satisfactionTeacherEnum[satisfactionTeacherEnum["\u611F\u52D5\u3057\u305F"] = 2] = "\u611F\u52D5\u3057\u305F";
    satisfactionTeacherEnum[satisfactionTeacherEnum["\u65B0\u3057\u3044\u767A\u898B\u304C\u3042\u3063\u305F"] = 3] = "\u65B0\u3057\u3044\u767A\u898B\u304C\u3042\u3063\u305F";
    satisfactionTeacherEnum[satisfactionTeacherEnum["\u305D\u306E\u4ED6\u3088\u304B\u3063\u305F"] = 4] = "\u305D\u306E\u4ED6\u3088\u304B\u3063\u305F";
    satisfactionTeacherEnum[satisfactionTeacherEnum["\u4E0D\u6E80\u304C\u3042\u308B"] = 5] = "\u4E0D\u6E80\u304C\u3042\u308B";
})(satisfactionTeacherEnum || (satisfactionTeacherEnum = {}));
export var japaneseLevelEnum;
(function (japaneseLevelEnum) {
    japaneseLevelEnum[japaneseLevelEnum["\u30B9\u30E0\u30FC\u30BA\u306B\u4F1A\u8A71\u304C\u3067\u304D\u305F"] = 1] = "\u30B9\u30E0\u30FC\u30BA\u306B\u4F1A\u8A71\u304C\u3067\u304D\u305F";
    japaneseLevelEnum[japaneseLevelEnum["\u305F\u307E\u306B\u5358\u8A9E\u304C\u51FA\u306A\u3044\u3067\u3064\u307E\u3065\u3044\u305F"] = 2] = "\u305F\u307E\u306B\u5358\u8A9E\u304C\u51FA\u306A\u3044\u3067\u3064\u307E\u3065\u3044\u305F";
    japaneseLevelEnum[japaneseLevelEnum["\u7D9A\u304F\u3051\u3069\u3057\u3069\u308D\u3082\u3069\u308D"] = 3] = "\u7D9A\u304F\u3051\u3069\u3057\u3069\u308D\u3082\u3069\u308D";
    japaneseLevelEnum[japaneseLevelEnum["\u3042\u307E\u308A\u7D9A\u304B\u306A\u3044"] = 4] = "\u3042\u307E\u308A\u7D9A\u304B\u306A\u3044";
    japaneseLevelEnum[japaneseLevelEnum["\u307E\u3063\u305F\u304F\u4F1A\u8A71\u306B\u306A\u3089\u306A\u3044"] = 5] = "\u307E\u3063\u305F\u304F\u4F1A\u8A71\u306B\u306A\u3089\u306A\u3044";
})(japaneseLevelEnum || (japaneseLevelEnum = {}));
export var punctualityStudentEnum;
(function (punctualityStudentEnum) {
    punctualityStudentEnum[punctualityStudentEnum["On time"] = 1] = "On time";
    punctualityStudentEnum[punctualityStudentEnum["A little late"] = 2] = "A little late";
    punctualityStudentEnum[punctualityStudentEnum["Late for more than 5 minutes"] = 3] = "Late for more than 5 minutes";
    punctualityStudentEnum[punctualityStudentEnum["Did not show up"] = 4] = "Did not show up";
})(punctualityStudentEnum || (punctualityStudentEnum = {}));
export var punctualityTeacherEnum;
(function (punctualityTeacherEnum) {
    punctualityTeacherEnum[punctualityTeacherEnum["\u6642\u9593\u901A\u308A\u306B\u6765\u305F"] = 1] = "\u6642\u9593\u901A\u308A\u306B\u6765\u305F";
    punctualityTeacherEnum[punctualityTeacherEnum["\u5C11\u3057\u9045\u523B\u3057\u305F"] = 2] = "\u5C11\u3057\u9045\u523B\u3057\u305F";
    punctualityTeacherEnum[punctualityTeacherEnum["5\u5206\u4EE5\u4E0A\u9045\u523B\u3057\u305F"] = 3] = "5\u5206\u4EE5\u4E0A\u9045\u523B\u3057\u305F";
    punctualityTeacherEnum[punctualityTeacherEnum["\u3053\u306A\u304B\u3063\u305F"] = 4] = "\u3053\u306A\u304B\u3063\u305F";
})(punctualityTeacherEnum || (punctualityTeacherEnum = {}));
export var chatQualityStudentEnum;
(function (chatQualityStudentEnum) {
    chatQualityStudentEnum[chatQualityStudentEnum["The video lags occasionally"] = 1] = "The video lags occasionally";
    chatQualityStudentEnum[chatQualityStudentEnum["The video did not appear"] = 2] = "The video did not appear";
    chatQualityStudentEnum[chatQualityStudentEnum["Lots of surrounding noises"] = 3] = "Lots of surrounding noises";
    chatQualityStudentEnum[chatQualityStudentEnum["The voice occasionally gets interrupted"] = 4] = "The voice occasionally gets interrupted";
})(chatQualityStudentEnum || (chatQualityStudentEnum = {}));
export var chatQualityTeacherEnum;
(function (chatQualityTeacherEnum) {
    chatQualityTeacherEnum[chatQualityTeacherEnum["\u6620\u50CF\u304C\u305F\u307E\u306B\u5207\u308C\u3066\u305F"] = 1] = "\u6620\u50CF\u304C\u305F\u307E\u306B\u5207\u308C\u3066\u305F";
    chatQualityTeacherEnum[chatQualityTeacherEnum["\u307E\u3063\u305F\u304F\u6620\u3089\u306A\u304B\u3063\u305F"] = 2] = "\u307E\u3063\u305F\u304F\u6620\u3089\u306A\u304B\u3063\u305F";
    chatQualityTeacherEnum[chatQualityTeacherEnum["\u5468\u56F2\u306E\u96D1\u97F3\u304C\u591A\u304B\u3063\u305F"] = 3] = "\u5468\u56F2\u306E\u96D1\u97F3\u304C\u591A\u304B\u3063\u305F";
    chatQualityTeacherEnum[chatQualityTeacherEnum["\u97F3\u58F0\u304C\u30D6\u30C4\u30D6\u30C4\u5207\u308C\u3066\u305F"] = 4] = "\u97F3\u58F0\u304C\u30D6\u30C4\u30D6\u30C4\u5207\u308C\u3066\u305F";
})(chatQualityTeacherEnum || (chatQualityTeacherEnum = {}));
var reportReasonStudentEnum;
(function (reportReasonStudentEnum) {
    reportReasonStudentEnum[reportReasonStudentEnum["Recommendation of other services"] = 1] = "Recommendation of other services";
    reportReasonStudentEnum[reportReasonStudentEnum["Spam"] = 2] = "Spam";
    reportReasonStudentEnum[reportReasonStudentEnum["Obscenity/Asking for a meeting"] = 3] = "Obscenity/Asking for a meeting";
    reportReasonStudentEnum[reportReasonStudentEnum["Criminal/Illegal act"] = 4] = "Criminal/Illegal act";
    reportReasonStudentEnum[reportReasonStudentEnum["Others/Troubling act"] = 5] = "Others/Troubling act";
})(reportReasonStudentEnum || (reportReasonStudentEnum = {}));
var reportReasonTeacherEnum;
(function (reportReasonTeacherEnum) {
    reportReasonTeacherEnum[reportReasonTeacherEnum["\u4ED6\u30B5\u30FC\u30D3\u30B9\u3078\u306E\u52E7\u8A98\u884C\u70BA"] = 1] = "\u4ED6\u30B5\u30FC\u30D3\u30B9\u3078\u306E\u52E7\u8A98\u884C\u70BA";
    reportReasonTeacherEnum[reportReasonTeacherEnum["\u30B9\u30D1\u30E0\u30FB\u5BA3\u4F1D\u76EE\u7684"] = 2] = "\u30B9\u30D1\u30E0\u30FB\u5BA3\u4F1D\u76EE\u7684";
    reportReasonTeacherEnum[reportReasonTeacherEnum["\u51FA\u4F1A\u3044\u30FB\u308F\u3044\u305B\u3064\u76EE\u7684"] = 3] = "\u51FA\u4F1A\u3044\u30FB\u308F\u3044\u305B\u3064\u76EE\u7684";
    reportReasonTeacherEnum[reportReasonTeacherEnum["\u72AF\u7F6A\u30FB\u9055\u6CD5\u884C\u70BA"] = 4] = "\u72AF\u7F6A\u30FB\u9055\u6CD5\u884C\u70BA";
    reportReasonTeacherEnum[reportReasonTeacherEnum["\u305D\u306E\u4ED6\u3001\u8FF7\u60D1\u884C\u70BA"] = 5] = "\u305D\u306E\u4ED6\u3001\u8FF7\u60D1\u884C\u70BA";
    reportReasonTeacherEnum[reportReasonTeacherEnum["\u4F1A\u8A71\u304C\u3067\u304D\u306A\u304B\u3063\u305F"] = 6] = "\u4F1A\u8A71\u304C\u3067\u304D\u306A\u304B\u3063\u305F";
})(reportReasonTeacherEnum || (reportReasonTeacherEnum = {}));
const satisfactionChoiceObjBuilder = (satisfactionEnum) => enumToObject(satisfactionEnum).map((choice, index) => (Object.assign(Object.assign({}, choice), { emojiName: emojiNameArr[index] })));
export const satisfactionChoices = {
    student: satisfactionChoiceObjBuilder(satisfactionStudentEnum),
    teacher: satisfactionChoiceObjBuilder(satisfactionTeacherEnum),
};
export const japaneseLevelChoices = enumToObject(japaneseLevelEnum);
export const punctualityChoices = {
    student: enumToObject(punctualityStudentEnum),
    teacher: enumToObject(punctualityTeacherEnum),
};
export const chatQualityChoices = {
    student: enumToObject(chatQualityStudentEnum),
    teacher: enumToObject(chatQualityTeacherEnum),
};
export const reportReasonChoices = {
    student: enumToObject(reportReasonStudentEnum),
    teacher: enumToObject(reportReasonTeacherEnum),
};
export const thumbsDownImages = {
    notChosen: resolvePath.image('common/evaluation/thumbs-down-normal.svg'),
    satisfied: resolvePath.image('common/evaluation/thumbs-down-faded.svg'),
    unsatisfied: resolvePath.image('common/evaluation/thumbs-down-selected.svg'),
};
export const thumbsUpImages = {
    notChosen: resolvePath.image('common/evaluation/thumbs-up-normal.svg'),
    satisfied: resolvePath.image('common/evaluation/thumbs-up-selected.svg'),
    unsatisfied: resolvePath.image('common/evaluation/thumbs-up-faded.svg'),
};
export const thumbsDownColors = {
    background: {
        notChosen: colors.white,
        satisfied: colors.white,
        unsatisfied: colors.darkGray,
    },
    border: {
        notChosen: colors.darkGray,
        satisfied: colors.white,
        unsatisfied: colors.darkGray,
    },
    text: {
        notChosen: colors.darkGray,
        satisfied: colors.mediumGray,
        unsatisfied: colors.darkGray,
    },
};
export const thumbsUpColors = {
    background: {
        notChosen: colors.white,
        satisfied: colors.sailBlue,
        unsatisfied: colors.white,
    },
    border: {
        notChosen: colors.sailBlue,
        satisfied: colors.sailBlue,
        unsatisfied: colors.white,
    },
    text: {
        notChosen: colors.sailBlue,
        satisfied: colors.sailBlue,
        unsatisfied: colors.mediumGray,
    },
};
export const ConversationCategoryLabelJP = {
    [ConversationCategory.Other]: 'その他',
    [ConversationCategory.DailyLife]: '日常生活',
    [ConversationCategory.Work]: '仕事',
    [ConversationCategory.Travel]: '旅行',
    [ConversationCategory.PartnersCountry]: '相手の国のこと',
};
export const ConversationCategoryLabelEN = {
    [ConversationCategory.Other]: 'Other',
    [ConversationCategory.DailyLife]: 'Daily Life',
    [ConversationCategory.Work]: 'Work',
    [ConversationCategory.Travel]: 'Travel',
    [ConversationCategory.PartnersCountry]: 'About Japan',
};
export const ReportReasonLabelJP = {
    [ReportReason.OtherServices]: '他サービスへの勧誘行為',
    [ReportReason.Spam]: 'スパム・宣伝目的',
    [ReportReason.Obscenity]: '出会い・わいせつ目的',
    [ReportReason.Criminal]: '犯罪・違法行為',
    [ReportReason.Other]: 'その他、迷惑行為',
    [ReportReason.PartnerUnable]: '会話ができなかった',
};
export const ReportReasonLabelEN = {
    [ReportReason.OtherServices]: 'Recommendation of other services',
    [ReportReason.Spam]: 'Spam',
    [ReportReason.Obscenity]: 'Obscenity/Asking for a meeting',
    [ReportReason.Criminal]: 'Criminal/Illegal act',
    [ReportReason.Other]: 'Others/Troubling act',
};
